export default __webpack_public_path__ + "static/welcome-man-l3-42b8bbabeb8de412aea8026c5125fa2b.png";